(function ($) {
  $(document).ready(function () {
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (width > 768) {
      setTimeout(function () {
        $(".icon_slider").owlCarousel("refresh");
      }, 100);
    }
    $(".icon_slider").owlCarousel({
      loop: false,
      items: 5,
      margin: 30,
      mouseDrag: false,
      nav: false,
      responsive: {
        0: {
          loop: false,
          items: 3,
          margin: 20,
          stagePadding: 28,
        },
        768: {
          loop: true,
          mouseDrag: false,
          margin: 90,
          items: 5,
        },
        1000: {
          loop: true,
          items: 5,
        },
      },
    });

    $(".product-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplay: false,
      dots: true,
      mouseDrag: false,
      margin: 30,
      nav: false,
      responsive: {
        750: {
          dots: false,
          URLhashListener: true,
          startPosition: "URLHash",
        },
      },
    });

    $(".rs-carousel").each(function () {
      var owlCarousel = $(this);
      ((loop = owlCarousel.data("loop")),
        (loopMobile = owlCarousel.data("loop-mobile")),
        (items = owlCarousel.data("items")),
        (margin = owlCarousel.data("margin")),
        (marginTab = owlCarousel.data("margin-tab")),
        (marginMob = owlCarousel.data("margin-mobile")),
        (autoplay = owlCarousel.data("autoplay")),
        (autoplayTimeout = owlCarousel.data("autoplay-timeout")),
        (smartSpeed = owlCarousel.data("smart-speed")),
        (center = owlCarousel.data("center")),
        (dots = owlCarousel.data("dots")),
        (nav = owlCarousel.data("nav")),
        (navSpeed = owlCarousel.data("nav-speed")),
        (xsDevice = owlCarousel.data("mobile-device")),
        (xsDeviceNav = owlCarousel.data("mobile-device-nav")),
        (xsDeviceDots = owlCarousel.data("mobile-device-dots")),
        (smDevice = owlCarousel.data("ipad-device")),
        (smDeviceNav = owlCarousel.data("ipad-device-nav")),
        (smDeviceDots = owlCarousel.data("ipad-device-dots")),
        (mdDevice = owlCarousel.data("md-device")),
        (touchDrag = owlCarousel.data("drag")),
        (mdDeviceNav = owlCarousel.data("md-device-nav")),
        (stagePadding = owlCarousel.data("stage-padding")),
        (stagePadding_mob = owlCarousel.data("stage-padding-mobile")),
        (stagePadding_tab = owlCarousel.data("stage-padding-tab")),
        (scrollbarType = owlCarousel.data("scrollbar-type")),
        (mdDeviceDots = owlCarousel.data("md-device-dots")));

      owlCarousel.owlCarousel({
        loop: loop ? true : false,
        mouseDrag: false,
        items: items ? items : 4,
        lazyLoad: false,
        stagePadding: stagePadding ? stagePadding : 0,
        margin: margin ? margin : 0,
        scrollbarType: scrollbarType ? scrollbarType : "",
        autoplay: autoplay ? true : false,
        autoplayTimeout: autoplayTimeout ? autoplayTimeout : 1000,
        smartSpeed: smartSpeed ? smartSpeed : 250,
        dots: dots ? true : false,
        nav: nav ? true : false,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
        navSpeed: navSpeed ? true : false,
        responsiveClass: true,
        responsive: {
          0: {
            items: xsDevice ? xsDevice : 1,
            nav: xsDeviceNav ? true : false,
            stagePadding: stagePadding_mob,
            margin: marginMob,
            dots: xsDeviceDots ? true : false,
            loop: loopMobile,
          },
          768: {
            items: smDevice ? smDevice : 3,
            nav: smDeviceNav ? true : false,
            stagePadding: stagePadding_tab,
            margin: marginTab ? marginTab : 0,
            dots: smDeviceDots ? true : false,
          },
          1200: {
            items: mdDevice ? mdDevice : 4,
            nav: mdDeviceNav ? true : false,
            dots: mdDeviceDots ? true : false,
          },
        },
      });
    });

    $(".author____boxes").each(function () {
      var owlCarousel = $(this);
      ((loop = owlCarousel.data("loop")),
        (items = owlCarousel.data("items")),
        (margin = owlCarousel.data("margin")),
        (autoplay = owlCarousel.data("autoplay")),
        (autoplayTimeout = owlCarousel.data("autoplay-timeout")),
        (smartSpeed = owlCarousel.data("smart-speed")),
        (dots = owlCarousel.data("dots")),
        (nav = owlCarousel.data("nav")),
        (navSpeed = owlCarousel.data("nav-speed")),
        (xsDevice = owlCarousel.data("mobile-device")),
        (xsDeviceNav = owlCarousel.data("mobile-device-nav")),
        (xsDeviceDots = owlCarousel.data("mobile-device-dots")),
        (smDevice = owlCarousel.data("ipad-device")),
        (smDeviceNav = owlCarousel.data("ipad-device-nav")),
        (smDeviceDots = owlCarousel.data("ipad-device-dots")),
        (mdDevice = owlCarousel.data("md-device")),
        (mdDeviceNav = owlCarousel.data("md-device-nav")),
        (stagePadding = owlCarousel.data("stage-padding")),
        (stagePadding_tab = owlCarousel.data("stage-padding-tab")),
        (scrollbarType = owlCarousel.data("scrollbar-type")),
        (mdDeviceDots = owlCarousel.data("md-device-dots")),
        (lgDevice = owlCarousel.data("lg-device")),
        (lgDeviceNav = owlCarousel.data("lg-device-nav")),
        (lgDeviceDots = owlCarousel.data("lg-device-dots")));

      owlCarousel.owlCarousel({
        loop: loop ? true : false,
        items: items ? items : 4,
        lazyLoad: true,
        stagePadding: stagePadding ? stagePadding : 0,
        margin: margin ? margin : 0,
        scrollbarType: scrollbarType ? scrollbarType : "",
        autoplay: autoplay ? true : false,
        autoplayTimeout: autoplayTimeout ? autoplayTimeout : 1000,
        smartSpeed: smartSpeed ? smartSpeed : 250,
        dots: dots ? true : false,
        mouseDrag: false,
        nav: nav ? true : false,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
        navSpeed: navSpeed ? true : false,
        responsiveClass: true,
        responsive: {
          0: {
            items: xsDevice ? xsDevice : 1,
            nav: xsDeviceNav ? true : false,
            stagePadding: 0,
            center: true,
            dots: xsDeviceDots ? true : false,
          },
          768: {
            items: smDevice ? smDevice : 3,
            nav: smDeviceNav ? true : false,
            stagePadding: stagePadding_tab,
            dots: smDeviceDots ? true : false,
          },
          1250: {
            items: mdDevice ? mdDevice : 4,
            nav: mdDeviceNav ? true : false,
            dots: mdDeviceDots ? true : false,
          },
          1500: {
            items: lgDevice ? lgDevice : 4,
            nav: lgDeviceNav ? true : false,
            dots: lgDeviceDots ? true : false,
          },
        },
      });
    });

    $(".Video_url").each(function () {
      var owlCarousel = $(this);
      ((loop = owlCarousel.data("loop")),
        (items = owlCarousel.data("items")),
        (margin = owlCarousel.data("margin")),
        (autoplay = owlCarousel.data("autoplay")),
        (autoplayTimeout = owlCarousel.data("autoplay-timeout")),
        (smartSpeed = owlCarousel.data("smart-speed")),
        (dots = owlCarousel.data("dots")),
        (nav = owlCarousel.data("nav")),
        (navSpeed = owlCarousel.data("nav-speed")),
        (xsDevice = owlCarousel.data("mobile-device")),
        (xsDeviceNav = owlCarousel.data("mobile-device-nav")),
        (xsDeviceDots = owlCarousel.data("mobile-device-dots")),
        (smDevice = owlCarousel.data("ipad-device")),
        (smDeviceNav = owlCarousel.data("ipad-device-nav")),
        (smDeviceDots = owlCarousel.data("ipad-device-dots")),
        (mdDevice = owlCarousel.data("md-device")),
        (mdDeviceNav = owlCarousel.data("md-device-nav")),
        (stagePadding = owlCarousel.data("stage-padding")),
        (scrollbarType = owlCarousel.data("scrollbar-type")),
        (mdDeviceDots = owlCarousel.data("md-device-dots")));

      owlCarousel.owlCarousel({
        loop: loop ? true : false,
        items: items ? items : 4,
        lazyLoad: true,
        stagePadding: stagePadding ? stagePadding : 0,
        margin: margin ? margin : 0,
        scrollbarType: scrollbarType ? scrollbarType : "",
        autoplay: autoplay ? true : false,
        autoplayTimeout: autoplayTimeout ? autoplayTimeout : 1000,
        smartSpeed: smartSpeed ? smartSpeed : 250,
        dots: dots ? true : false,
        nav: nav ? true : false,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
        navSpeed: navSpeed ? true : false,
        mouseDrag: false,
        responsiveClass: true,

        responsive: {
          0: {
            items: xsDevice ? xsDevice : 1,
            nav: xsDeviceNav ? true : false,
            stagePadding: 50,
            center: true,
            dots: xsDeviceDots ? true : false,
          },
          768: {
            items: smDevice ? smDevice : 3,
            nav: smDeviceNav ? true : false,
            dots: smDeviceDots ? true : false,
            margin: 25,
            stagePadding: 50,
          },
          1200: {
            items: mdDevice ? mdDevice : 4,
            nav: mdDeviceNav ? true : false,
            dots: mdDeviceDots ? true : false,
          },
        },
      });
    });

    var $announcementcarousel = $(".anouncement_carousel");
    var owlActive = false;

    function toggleOwl() {
      if (window.innerWidth < 768) {
        // mobile breakpoint
        if (!owlActive) {
          $announcementcarousel.owlCarousel({
            items: 3,
            nav: false,
            responsive: {
              0: {
                loop: true,
                items: 1,
                autoplay: true,
                autoplayTimeout: 3000,
              },
            },
          });
          owlActive = true;
        }
      } else {
        if (owlActive) {
          $announcementcarousel.trigger("destroy.owl.carousel");
          $announcementcarousel.removeClass("owl-loaded");
          $announcementcarousel.find(".owl-stage-outer").children().unwrap(); // unwrap extra Owl markup
          owlActive = false;
        }
      }
    }

    // Run on load and resize
    toggleOwl();
    $(window).on("resize", toggleOwl);

    if (window.location.hash) {
      setTimeout(() => {
        window.scrollTo({
          top:
            document
              .querySelector(window.location.hash)
              ?.getBoundingClientRect().top +
            window.scrollY -
            50,
          behavior: "smooth",
        });
      }, 600);
    }

    /* Youtube Video */

    jQuery("a.play-btn").click(function (e) {
      e.preventDefault();
      var Yid = jQuery(this).attr("rel");
      jQuery(this).hide();
      jQuery(this).parent().find("video").trigger("play");
      jQuery(this).parent().find("video").attr("controls", true);
    });

    $(".author_infobox").each(function () {
      $(this).on("click", function () {
        var val = $(this).attr("rel");
        $(".tooltip-popup-" + val).fadeIn();
        $(".authorboxmain_" + val).addClass("scroll_open");
      });
    });

    $(".tooltip-popup_close_btn").each(function () {
      $(this).on("click", function () {
        var val = $(this).attr("rel");
        $(".tooltip-popup-" + val).fadeOut();
        $(".authorboxmain_" + val).removeClass("scroll_open");
      });
    });
  });
})(jQuery);

function goToNutritional() {
  jQuery(".product-carousel .owl-dots .owl-dot:last").trigger("click");
}
function accordionFun(pid) {
  jQuery(".itme_no_" + pid)
    .find("h4")
    .trigger("click");
  jQuery(".itme_no_" + pid)
    .find("h4")
    .addClass("sdfljdklfjldkf");
}

$(function () {
  $(window).scroll(function () {
    if ($(".section-header").hasClass("scrolled-past-header")) {
      $("body").addClass("stickyHeaderContent");
    } else {
      $("body").removeClass("stickyHeaderContent");
    }
  });
});

/*
JTPL 
*/

$(document).ready(function () {
  if ($(window).width() < 749) {
    $(".icons-container").each(function () {
      var owlCarousel = $(this);
      ((loop = owlCarousel.data("loop")),
        (loopMobile = owlCarousel.data("loop-mobile")),
        (items = owlCarousel.data("items")),
        (margin = owlCarousel.data("margin")),
        (marginTab = owlCarousel.data("margin-tab")),
        (marginMob = owlCarousel.data("margin-mobile")),
        (autoplay = owlCarousel.data("autoplay")),
        (autoplayTimeout = owlCarousel.data("autoplay-timeout")),
        (smartSpeed = owlCarousel.data("smart-speed")),
        (center = owlCarousel.data("center")),
        (dots = owlCarousel.data("dots")),
        (nav = owlCarousel.data("nav")),
        (navSpeed = owlCarousel.data("nav-speed")),
        (xsDevice = owlCarousel.data("mobile-device")),
        (xsDeviceNav = owlCarousel.data("mobile-device-nav")),
        (xsDeviceDots = owlCarousel.data("mobile-device-dots")),
        (smDevice = owlCarousel.data("ipad-device")),
        (smDeviceNav = owlCarousel.data("ipad-device-nav")),
        (smDeviceDots = owlCarousel.data("ipad-device-dots")),
        (mdDevice = owlCarousel.data("md-device")),
        (touchDrag = owlCarousel.data("drag")),
        (mdDeviceNav = owlCarousel.data("md-device-nav")),
        (stagePadding = owlCarousel.data("stage-padding")),
        (stagePadding_mob = owlCarousel.data("stage-padding-mobile")),
        (stagePadding_tab = owlCarousel.data("stage-padding-tab")),
        (scrollbarType = owlCarousel.data("scrollbar-type")),
        (mdDeviceDots = owlCarousel.data("md-device-dots")));

      owlCarousel.owlCarousel({
        loop: loop ? true : false,
        mouseDrag: false,
        items: items ? items : 4,
        lazyLoad: false,
        stagePadding: stagePadding ? stagePadding : 0,
        margin: margin ? margin : 0,
        scrollbarType: scrollbarType ? scrollbarType : "",
        autoplay: autoplay ? true : false,
        autoplayTimeout: autoplayTimeout ? autoplayTimeout : 1000,
        smartSpeed: smartSpeed ? smartSpeed : 250,
        dots: dots ? true : false,
        nav: nav ? true : false,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
        navSpeed: navSpeed ? true : false,
        responsiveClass: true,
        responsive: {
          0: {
            items: xsDevice ? xsDevice : 4,
            nav: xsDeviceNav ? true : false,
            stagePadding: stagePadding_mob,
            margin: marginMob,
            dots: xsDeviceDots ? true : false,
            loop: loopMobile,
          },
          768: {
            items: smDevice ? smDevice : 4,
            nav: smDeviceNav ? true : false,
            stagePadding: stagePadding_tab,
            margin: marginTab ? marginTab : 0,
            dots: smDeviceDots ? true : false,
          },
          1200: {
            items: mdDevice ? mdDevice : 4,
            nav: mdDeviceNav ? true : false,
            dots: mdDeviceDots ? true : false,
          },
        },
      });
    });
  }

  $(document).on("click", ".button.addToCart", function (e) {
    const path = window.location.pathname;
    if (path.includes("products/smart-supplement")) {
      $(".product-form__submit").click();
    } else {
      window.location.href = "/products/smart-supplement";
    }
  });

  $(".question").click(function () {
    // Toggle the answer of the clicked question
    $(this).children(".answer").slideToggle(300);
    $(this).toggleClass("faq-open");
    $(this).nextAll(".question").removeClass("faq-open");
  });

  $(
    ".temp-product .section.accordion-new.pdp-fq-accordion-cstm .accordion-item-new-cstm",
  )
    .find(".accordion-content-container .accordion-content-new-cstm")
    .slideUp();

  $(document).on(
    "click",
    ".temp-product .section.accordion-new.pdp-fq-accordion-cstm .accordion-item-new-cstm",
    function () {
      $(this)
        .find(".accordion-content-container .accordion-content-new-cstm")
        .slideToggle();
      $(this).toggleClass("faq-open");
    },
  );

  $("body").on("click", ".faq-heading", function () {
    $(".answer").slideUp(300);
    $(".faq-heading").removeClass("active-faq");
    $(this).addClass("active-faq");
    var showFaq = $(this).attr("data-class");

    $(".question").removeClass("active-faq");
    $(".question." + showFaq).addClass("active-faq");
    $(".question").removeClass("faq-open");
  });

  var mainWidth = $(
    ".skio-group-container.skio-group-container--available",
  ).width();
  $(".home_icons_carousel .jtpl-carousel").css("max-width", mainWidth);

  if ($(window).width() < 1025) {
    $(document).on("click", ".faq-tabs-heading-container", function () {
      $(".fat-tabs-main").css("display", "block");
      $(".faq").addClass("faq-menu-open");
    });
    $(document).on("click", ".faq-heading", function () {
      var selectedTab = $(this).attr("data-name");
      $(".active-faq-tab").text(selectedTab);
      $(".fat-tabs-main").css("display", "none");
      $(".faq").removeClass("faq-menu-open");
    });

    $(".fat-tabs-main").css("display", "none");
    $(document).on("click", ".faq-tabs-heading-container", function () {
      $(".fat-tabs-main").css("display", "flex");
      $(".faq").addClass("faq-menu-open");
    });

    $(document).on("click", ".faq-heading", function (e) {
      e.stopPropagation();
      var selectedTab = $(this).attr("data-name");
      $(".active-faq-tab").text(selectedTab);
      $(".fat-tabs-main").css("display", "none!important");
      $(".faq").removeClass("faq-menu-open");
    });
  }
});

// Google Ads Lander
document.addEventListener("DOMContentLoaded", function () {
  // if is product page
  if (window.location.pathname.includes("/products/")) {
    // if url params has "selected=one-time"
    if (window.location.search.includes("selected=one-time")) {
      const options = document.querySelectorAll(
        ".skio-group-container.skio-group-container--available",
      );
      // if option has child with id that starts with "skio-one-time-"
      options.forEach((option) => {
        const oneTimePurchaseButton = option.querySelector(
          "input[id^='skio-one-time-']",
        );

        if (oneTimePurchaseButton) {
          setTimeout(() => {
            option.querySelector(".skio-group-label").click();
          }, 500);
        }
      });
    }
  }
});
